var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf1Right(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247.82 331.23",
    style: {
      enableBackground: "new 0 0 247.82 331.23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.07,271.04c10.62-14.81,14.15-32.68,20.49-49.41c2.56-6.75,6.04-13.16,9.1-19.73 c0.38,0.17,0.76,0.34,1.14,0.51c-0.98,7.58-1.48,15.26-3.08,22.7c-1.63,7.58-3.44,15.36-6.84,22.24 c-3.29,6.66-8.69,12.28-13.17,18.36c0.6,0.61,1.2,1.21,1.8,1.82c18.85-18.12,44.48-26.23,63.59-44.35 C212.22,255.09,185.38,267.17,153.07,271.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.41,273.53c-16.55,16.17-35.55,24.15-58.88,19.19c-9.73-2.07-19.46-4.13-30.78-6.53 c23.71-7.47,34.82-27.84,51.11-42.68c-1.18,13.35-14.44,31.29-26.24,35.93c-8.56,3.36-8.56,3.36-10.17,6.76 c11-1.65,21.95-3.45,32.94-4.87c5.59-0.72,11.4-0.13,16.89-1.22C176.64,278.44,184.81,275.83,193.41,273.53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.37,166.07c-1.9,35.38-28.23,51.98-54.43,70.1c8.84-22.91,4.33-46.6,9.53-69.03 c0.33-1.43,0.65-2.86,2.12-4.34c1.31,10.39,2.73,20.77,3.9,31.17c1.22,10.86-3.19,20.55-8.21,30.07c0.72,0.36,1.43,0.72,2.15,1.08 c1.63-1.61,3.53-3.03,4.85-4.86c3.8-5.26,7.14-10.85,11.07-16.01c4.73-6.2,10.07-11.95,14.8-18.15 C234.04,179.67,238.53,172.92,243.37,166.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.03,115.98c12.48,17.66,21.65,36.26,15.55,59.23c0.6,0.06,1.2,0.11,1.79,0.17 c0.84-0.79,2.01-1.42,2.44-2.39c0.94-2.11,1.91-4.34,2.14-6.59c1.59-15.64,7.98-29.76,13.47-44.2c1.69-4.44,2.66-9.15,3.96-13.74 c6.01,29.52-4.75,53.73-24.16,74.72c-5.53-22.01-11.16-44.39-16.78-66.78C199.97,116.27,200.5,116.13,201.03,115.98z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.09,51.8c10.38,16.94,11.82,34.24,6.59,52.33c-2.49,8.61-5.2,17.16-7.48,24.68 c-8.74-13.06-18.12-26.68-27.01-40.61c-2.86-4.48-4.39-9.81-6.01-14.97c13.22,11.42,27.18,22.14,29.52,41.12 c0.17,1.37,1.97,2.54,3.02,3.81c0.4-1.46,1.3-2.99,1.12-4.38c-2.1-15.46-0.9-30.88,0.2-46.32C223.39,62.52,223.09,57.54,223.09,51.8 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,292.67c3.53-1.09,7-2.57,10.62-3.19c12.01-2.05,23.78-1.49,35.16,3.55c6.52,2.89,13.39,5,19.9,7.91 c13.32,5.96,27.04,7.68,41.46,5.02c-7.34,5.93-15.7,9.4-25.03,10.47c-10.92,1.25-21.23-0.78-30.62-6.55 c-4.94-3.04-9.96-6.11-14.37-9.84c-10.33-8.72-21.64-11.91-34.73-7.67c-0.76,0.25-1.64,0.14-2.47,0.2L50.5,292.67z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.41,36.47c7.41,5.58,14.95,10.33,21.34,16.32c6.29,5.88,11.41,13.01,16.97,19.5 c1.18-1.73-8.15-37.62-14.07-52.12c9.74,7.57,15.82,16.51,16.67,27.88c0.82,10.9,0.18,21.9,0.18,33.41 C198.74,66.26,179.02,57,171.41,36.47z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.15,40.06C175.75,30.82,167.79,14.14,157.04,0C173.32,2.77,190.8,22.69,192.15,40.06z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.42,292.57c-18.14,9.16-31.73,23.7-45.36,38.66c-1.64-1.46-3.18-2.84-5.06-4.52 c11.56-13.01,24.78-23.34,40.28-30.63c3.23-1.52,6.8-2.3,10.22-3.42C50.5,292.67,50.42,292.57,50.42,292.57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf1Right);
export default __webpack_public_path__ + "static/media/leaf1_right.c1da7927b6bbce609eab9362f00f8d7e.svg";
export { ForwardRef as ReactComponent };